import ControlledTable from "@/components/controlled-table";
import BasicTableWidget from "@/components/controlled-table/basic-table-widget";
import { HeaderCell } from "@/components/legacy-table";
import { Client } from "@/types";
import cn from "@/utils/class-names";
import { Badge, Text } from "rizzui";

interface PersonalInfoProps {
    client: Client;
    className?: string;
}

export default function PersonalInformation({
    client,
    className,
}: PersonalInfoProps) {

    const getColumns = () => [
        {
            title: <HeaderCell title="Country" />,
            dataIndex: "country",
            key: "country",
            width: 200,
            render: (country: string) => <Text>{country}</Text>,
        },
        {
            title: <HeaderCell title="Fullname" />,
            dataIndex: "fullname",
            key: "fullname",
            width: 300,
            render: (fullname: string) => <Text>{fullname}</Text>,
        },
        {
            title: <HeaderCell title="mobile" />,
            dataIndex: "mobile",
            key: "mobile",
            width: 200,
            render: (mobile: string) => <Text>{mobile}</Text>,
        },
        {
            title: <HeaderCell title="Email" />,
            dataIndex: "email",
            key: "email",
            width: 200,
            render: (email: string) => <Text>{email}</Text>,
        },
        {
            title: <HeaderCell title="Gender" />,
            dataIndex: "gender",
            key: "gender",
            width: 150,
            render: (gender: string) => <Text>{gender}</Text>,
        },
        {
            title: (
                <HeaderCell title="ClientType" className="me-6 justify-end" />
            ),
            dataIndex: "clientType",
            key: "clientType",
            width: 150,
            render: (clientType: string) => {
                return clientType === "Owner" ? (
                    <Badge variant="flat" color="success" size="sm">
                        {clientType}
                    </Badge>
                ) : (
                    <Badge variant="flat" color="warning" size="sm">
                        {clientType}
                    </Badge>
                );
            },
        },
    ];

    return (
        <ControlledTable
            data={[client]}
            columns={getColumns()}
            scroll={{ x: "100%", y: 240 }}
            sticky={true}
            variant="modern"
            className="mt-4"
        />
    );
}
